<template>
  <div class="row custom-items-four">
    <div class="col-12 d-flex text-center align-items-center justify-content-center mb-2">
      <div v-if="quote_data != undefined">
        <h2 class="font-weight-bold mx-auto" v-bind:style="{color : this.settings_style.colors != undefined ? this.settings_style.colors[2].color_value : 'white'}" v-if="quote_data.details.title != null && quote_data.details.title != null">
          {{quote_data.details.title}}
        </h2>
      </div>
      <div v-else>
        <h2 class="font-weight-bold mx-auto" v-bind:style="{color : this.settings_style.colors != undefined ? this.settings_style.colors[2].color_value : 'white'}">Toma de fotografías - Danone</h2>
      </div>
      
      <a class="ml-auto d-flex align-items-center download-btn px-3 py-1" v-if="this.settings_style.view_download_pdf && quote_data != undefined" v-bind:style="{color : this.settings_style.colors != undefined ? this.settings_style.colors[2].color_value : 'white'}" :href="this.urlApi+'imprimir/cotizacion/'+quote_data.quoteId" target="_blank">
        <i class="icon-cot-pdf mr-2" style="font-size:1.5rem;"/>
        <span>Descargar</span>
      </a>
      <div class="ml-auto d-flex align-items-center download-btn px-3 py-1" v-if="this.settings_style.view_download_pdf && quote_data == undefined" v-bind:style="{color : this.settings_style.colors != undefined ? this.settings_style.colors[2].color_value : 'white'}">
        <i class="icon-cot-pdf mr-2" style="font-size:1.5rem;"/>
        <span>Descargar</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      urlApi: process.env.VUE_APP_API_ENDPOINT
    }
  },
  props: {
    settings_style: {
      required: true,
    },
    quote_data:{
      type:Object
    }
  },
};
</script>